import React, { ReactNode } from 'react';
import Select, { SingleValue } from 'react-select';
import { joinClassNames } from '../../../utils';

export interface DropdownOption {
  label: string | ReactNode;
  value: any;
  url?: string;
}

interface DropdownProps {
  label: string;
  options: DropdownOption[];
  onChangeSelected: (newValue: SingleValue<DropdownOption>) => void;
  extraClassName?: string;
  defaultValue?: DropdownOption;
  value?: DropdownOption;
  placeholder?: string;
  isDisabled?: false;
  isLoading?: boolean;
  isSearchable?: boolean;
  isClearable?: boolean;
  noOptionsMessage?: string;
}

export const Dropdown = ({
  label,
  options,
  onChangeSelected,
  defaultValue,
  value,
  placeholder,
  extraClassName = '',
  isDisabled = false,
  isLoading = false,
  isSearchable = false,
  isClearable = false,
  noOptionsMessage = 'Não foram encontrados resultados...',
}: DropdownProps) => {
  return (
    <div data-testid='dropdown' className={joinClassNames(extraClassName)}>
      <label className='w-full input-label'>{label}</label>
      <Select
        isDisabled={isDisabled}
        isClearable={isClearable}
        getOptionValue={(option: DropdownOption) => option.label as string}
        isSearchable={isSearchable}
        onChange={onChangeSelected}
        classNames={{
          control: () => 'evolve-dropdown',
        }}
        classNamePrefix='evolve-dropdown'
        placeholder={
          placeholder ||
          (isSearchable
            ? `Procurar por ${label.toLocaleLowerCase()}...`
            : `Selecionar ${label.toLocaleLowerCase()}`)
        }
        options={options}
        isLoading={isLoading}
        noOptionsMessage={() => noOptionsMessage}
        defaultValue={defaultValue}
        value={value}
      />
    </div>
  );
};
